import { put, call, takeLatest } from 'redux-saga/effects';
// components
import { openLoader, closeLoader } from '../../../../components/loader/actions';
// helpers/constants
import * as GC from '../../../../constants';
// sagas
import { visitPageSaga } from '../../../../sagas';
// feature configs
import * as A from '../../actions';
import { getConfigByGroupSaga } from '../../sagas';
//////////////////////////////////////////////////

function* handleVisitConfigTrailerPageSaga({ payload }) {
  while (true) { // eslint-disable-line
    yield call(visitPageSaga, payload, GC.CHECK_VISIT_CONFIG_TRAILER_PAGE);

    yield put(openLoader({ showDimmer: true }));

    yield call(getConfigByGroupSaga, GC.TRAILER_CONFIG_GROUP);

    yield put(A.getEquipmentServiceAutoCreateConfigListRequest(GC.TRAILER_CONFIG_GROUP));
    yield put(closeLoader());

    break;
  }
}

function* trailerConfigWatcherSaga() {
  yield takeLatest(GC.VISIT_CONFIG_TRAILER_PAGE, handleVisitConfigTrailerPageSaga);
}

export default trailerConfigWatcherSaga;
